"use client";

import { ArrowLeft, ArrowRight, Quote } from "lucide-react";
import { useState } from "react";
import { Button } from "@/components/ui/button";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function VoicesOfSuccess() {
  const {
    ref: headerRef,
    isVisible: headerVisible
  } = useRevealOnScroll<HTMLDivElement>();
  const {
    ref: featuredRef,
    isVisible: featuredVisible
  } = useRevealOnScroll<HTMLDivElement>();
  const {
    ref: carouselRef,
    isVisible: carouselVisible
  } = useRevealOnScroll<HTMLDivElement>();
  const carouselTestimonials = [{
    quote: "Nexus Talent Partners identified the exact leadership profile we needed to scale our operations globally.",
    author: "Marcus Thorne",
    position: "CTO, FinTech Solutions",
    image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1701280/img/testimonial_marcus_thorne.png",
    srcset: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1701280/img/testimonial_marcus_thorne.png-wvc-srcset",
    sizes: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1701280/img/testimonial_marcus_thorne.png-wvc-sizes"
  }, {
    quote: "The precision of their candidate matching is unparalleled. They understand the nuance of our culture.",
    author: "Elena Rodriguez",
    position: "Director, Global Operations",
    image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1701280/img/testimonial_elena_rodriguez.png",
    srcset: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1701280/img/testimonial_elena_rodriguez.png-wvc-srcset",
    sizes: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1701280/img/testimonial_elena_rodriguez.png-wvc-sizes"
  }, {
    quote: "Working with Nexus transformed our hiring process from a bottleneck into a strategic advantage.",
    author: "David Chen",
    position: "VP of Engineering, CloudScale",
    image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1701280/img/testimonial_david_chen.webp",
    srcset: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1701280/img/testimonial_david_chen.webp-wvc-srcset",
    sizes: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1701280/img/testimonial_david_chen.webp-wvc-sizes"
  }];
  const [activeIndex, setActiveIndex] = useState(0);
  const handlePrev = () => {
    setActiveIndex(prev => (prev - 1 + carouselTestimonials.length) % carouselTestimonials.length);
  };
  const handleNext = () => {
    setActiveIndex(prev => (prev + 1) % carouselTestimonials.length);
  };
  return <section data-section-id="4562" id="voices-of-success" className="bg-background text-foreground py-20 md:py-28 lg:py-32 px-4 md:px-8 lg:px-12 overflow-hidden">
      <div className="max-w-7xl mx-auto">
        {}
        <div ref={headerRef} className={`mb-16 md:mb-24 transition-all duration-700 ease-out ${headerVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-6"}`}>
          <p className="font-mono text-xs md:text-sm uppercase tracking-widest mb-6 text-primary">
            05 / Client Success Stories
          </p>
          <h2 className="font-default font-semibold text-4xl md:text-5xl lg:text-6xl xl:text-[64px] leading-[1.05] tracking-tight max-w-4xl text-foreground">
            Partnerships that define professional excellence.
          </h2>
          <div className="mt-12 h-px w-full bg-border" />
        </div>

        {}
        

        {}
        <div className="h-px w-full mb-12 md:mb-16 bg-border" />

        {}
        <div ref={carouselRef} className={`transition-all duration-700 delay-200 ease-out ${carouselVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-6"}`}>
          {}
          <div className="flex items-center justify-between mb-10">
            <p className="font-mono text-xs uppercase tracking-widest text-muted-foreground">
              More Success Stories
            </p>
            <div className="flex items-center gap-6">
              <span className="font-mono text-xs tracking-widest text-muted-foreground">
                {String(activeIndex + 1).padStart(2, "0")} / {String(carouselTestimonials.length).padStart(2, "0")}
              </span>
              <div className="flex items-center gap-2">
                <Button variant="ghost" size="icon" onClick={handlePrev} aria-label="Previous testimonial" className="rounded-lg h-9 w-9 hover:bg-muted border border-border">
                  <ArrowLeft className="w-4 h-4" strokeWidth={1.5} />
                </Button>
                <Button variant="ghost" size="icon" onClick={handleNext} aria-label="Next testimonial" className="rounded-lg h-9 w-9 hover:bg-muted border border-border">
                  <ArrowRight className="w-4 h-4" strokeWidth={1.5} />
                </Button>
              </div>
            </div>
          </div>

          {}
          <div className="grid grid-cols-1 md:grid-cols-3 gap-6 lg:gap-8">
            {carouselTestimonials.map((testimonial, i) => <div key={i} data-index={i} className={`p-8 md:p-10 transition-all duration-500 bg-muted ${activeIndex === i ? "opacity-100 border-primary" : "opacity-60 border-border"} border`}>
                <div className="flex items-center gap-4 mb-6">
                  <div className="relative">
                    <img src={testimonial.image} data-wvc-srcset={testimonial.srcset} data-wvc-sizes={testimonial.sizes} alt={testimonial.author} loading="lazy" decoding="async" className="w-12 h-12 rounded-lg object-cover" />
                  </div>
                  <span className="font-mono text-xs uppercase tracking-widest text-primary">
                    0{i + 1}
                  </span>
                </div>
                <blockquote>
                  <p className="font-default text-[17px] leading-relaxed mb-8 line-clamp-3 text-foreground">
                    "{testimonial.quote}"
                  </p>
                </blockquote>
                <div className="h-px w-8 mb-4 bg-muted-foreground" />
                <p className="font-mono text-xs uppercase tracking-widest text-foreground">
                  {testimonial.author}
                </p>
                <p className="font-mono text-[11px] uppercase tracking-widest mt-1 text-muted-foreground">
                  {testimonial.position}
                </p>
              </div>)}
          </div>
        </div>
      </div>
    </section>;
}